import { useState } from "react";

const HamburgerMenu = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="hamburger-wrapper">
      <button
        className={`hamburger ${open ? "active" : ""}`}
        onClick={() => setOpen(!open)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {open && (
        <div className="dropdown-menu">
          <h3>Quick Links</h3>
          <ul>
            <li><a href="#home" onClick={() => setOpen(false)}>Home</a></li>
            <li><a href="#products" onClick={() => setOpen(false)}>Products</a></li>
            <li><a href="#gallery" onClick={() => setOpen(false)}>Gallery</a></li>
            <li><a href="#services" onClick={() => setOpen(false)}>Services</a></li>
          </ul>

          <h3>Contact</h3>
          <p>
            📍 Main Market, Masrakh, Bihar<br />
            📞 9546525492
          </p>

          <h3>Timings</h3>
          <p>
            Mon–Sat: 8:00 AM – 8:00 PM<br />
            Sun: 8:00 AM – 8:00 PM
          </p>
        </div>
      )}
    </div>
  );
};

export default HamburgerMenu;
